import React from 'react';

const steps = [
  {
    title: 'Einfaches Formular ausfüllen',
    description: 'Nutzen Sie die Gelegenheit und füllen Sie unser Ankaufformular in weniger als 3 Minuten aus – so sichern Sie sich schnell und unkompliziert Ihr persönliches Angebot!',
    number: 1,
  },
  {
    title: 'Attraktives Angebot erhalten',
    description: 'Profitieren Sie von aktuellen Marktpreisen! Wir berechnen den Restwert Ihres Fahrzeugs und präsentieren Ihnen ein attraktives, maßgeschneidertes Angebot, das Sie begeistern wird.',
    number: 2,
  },
  {
    title: 'Stressfrei Ihr Auto verkaufen',
    description: 'Machen Sie den nächsten Schritt! Vereinbaren Sie ganz bequem einen Vor-Ort-Termin und verkaufen Sie Ihr Auto von zu Hause aus – einfach, schnell und stressfrei!',
    number: 3,
  },
];

export default function StepsSection({city}: {city: string}) {
  return (
    <section className="bg-white py-12 md:py-16 lg:py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Autoverwertung {city||"Coburg"} in 3 Schritten
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
         Verkaufen Sie Ihr Auto Ganz Einfach! In wenigen Schritten erfahren Sie den Wert Ihres Fahrzeugs und erhalten das beste Angebot für die Autoentsorgung. </p>
        </div>

        {/* Steps with connectors */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-0 relative">
          {steps.map((step, idx) => (
            <React.Fragment key={step.number}>
              <div
                className="flex flex-col items-center text-center px-4 md:px-8 animate-fadeIn"
                style={{ animationDelay: `${idx * 0.15 + 0.1}s` }}
              >
                <div className={`flex items-center justify-center w-16 h-16 rounded-full border-4 border-primary-light bg-white shadow-lg mb-4 transition-all duration-300 ${
                  idx === 0 ? 'animate-slideUp' : idx === 1 ? 'animate-fadeIn' : 'animate-slideUp'
                }`}>
                  <span className="text-2xl font-bold text-primary">{step.number}</span>
                </div>
                <h3 className="text-xl font-bold text-primary-dark mb-2">{step.title}</h3>
                <p className="text-gray-700 leading-relaxed text-base max-w-xs">{step.description}</p>
              </div>
              {idx < steps.length - 1 && (
                <div className="hidden md:flex flex-1 justify-center items-center">
                  <div className="h-1 w-16 bg-primary-light rounded-full mx-2 md:mx-4 animate-fadeIn" style={{ animationDelay: `${idx * 0.2 + 0.2}s` }}></div>
                </div>
              )}
              {idx < steps.length - 1 && (
                <div className="flex md:hidden w-1 h-8 bg-primary-light rounded-full my-2 animate-fadeIn" style={{ animationDelay: `${idx * 0.2 + 0.2}s` }}></div>
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            className="bg-primary-light hover:bg-primary text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-lg focus:outline-none"
            onClick={() => {
              const form = document.getElementById('contact-form');
              if (form) {
                form.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
            onMouseEnter={e => e.currentTarget.classList.add('animate-bounce')}
            onMouseLeave={e => e.currentTarget.classList.remove('animate-bounce')}
          >
            Autobewertung
          </button>
        </div>
      </div>
    </section>
  );
}